<template>
  <v-container class="pa-0" fluid ref="test">
    <video
      id="slowPlayer"
      v-show="false"
      class="video-js vjs-default-skin vjs-fluid"
      crossorigin="use-credentials"
      playsinline
      :width="150" :height="150"
    ></video>
    <!-- <select-dialog
      :dialog="phraseDialog"
      :array="$store.state.studying.phrases"
      :textparam="'dialogLabel'"
      :current-value="$store.getters.phrase.dialogLabel"
      :label="$store.state.tr.Select"
      :dense="true"
      @dismissed="phraseDialog = false"
      @selected="phraseSelected"
    ></select-dialog> -->
    <device-access
      v-if="(cameraActivity || micActivity) && !deviceEnabled"
      :cameraActivity="cameraActivity"
      @deviceEnabled="onDeviceEnabled"
    ></device-access>
    <pro-card
      v-else
      :showIf="activityReady && !$store.state.mainLoading"
      ref="card"
      :drillMovie="drillMovie"
      :mediaSrc="imageComputed"
      mediaStyle="max-height: 563px"
      :blurImage="blurImage"
    >
      <v-layout slot="loadingBar" justify-center style="position: absolute; left: 48%; top: 250px;">
        <v-progress-circular
          v-show="!activityReady"
          indeterminate
          :size="60" :width="2"
          color="primary"
          class="loader"
        ></v-progress-circular>
      </v-layout>
      <!-- <v-tooltip
        slot="beforeCard"
        :disabled="!($vuetify.breakpoint.mdAndUp && showPrevButton)"
        top
      >
        <left-btn
          v-show="(!wideActivity && $vuetify.breakpoint.mdAndUp)
          || (wideActivity && $vuetify.breakpoint.lgAndUp)"
          slot="activator"
          :style="showPrevButton ? 'opacity: 1;'
          : 'visibility: hidden; opacity: 0; transition: none !important'"
          :aria-label="prevButtonLabel"
          @click.native="onPrev"
        ></left-btn>
        <span dir="auto">{{ prevButtonLabel }}</span>
      </v-tooltip> -->
      <img
        slot="cardMedia"
        width="10px"
        height="10px"
        v-show="false"
        :src="imageComputed"
        alt=""
        @load="setActivityReady"
        @error="setActivityReady"
      />
      <img
        slot="cardMediaPreload"
        width="10px"
        height="10px"
        v-if="!showActivityPlayer"
        v-show="false"
        :src="imageComputedNext"
        alt=""
      />
      <v-container
        slot="cardVideoPlayer"
        v-show="showActivityPlayer"
        class="fluid pa-0"
        style="height: 100%; position: absolute; z-index: 2;"
      >
        <v-row
          v-show="cameraPlayerVisible"
          justify-center align-center pa-0 fill-height
          :style="'max-width: ' + activityPlayerWidth + 'px;'"
        >
          <video
            v-if="cameraActivity"
            id="cameraPlayer"
            class="video-js vjs-default-skin vjs-fluid"
            crossorigin="use-credentials"
            playsinline
            :width="activityPlayerWidth" :height="activityPlayerHeight"
          ></video>
        </v-row>
        <v-row
          v-show="!cameraPlayerVisible"
          class="justify-center align-center pa-0 fill-height"
        >
          <v-row
            :style="'max-width: ' + activityPlayerWidth + 'px;'">
            <video
              id="activityPlayer"
              class="video-js vjs-default-skin vjs-fluid mt-5"
              crossorigin="use-credentials"
              playsinline
              style="padding-top: 0;"
              :width="activityPlayerWidth" :height="activityPlayerHeight"
            ></video>
          </v-row>
        </v-row>
        <video
          id="preloadPlayer"
          v-show="false"
          class="video-js vjs-default-skin vjs-fluid"
          crossorigin="use-credentials"
          playsinline muted
          :width="activityPlayerWidth" :height="activityPlayerHeight"
        ></video>
      </v-container>
      <v-layout
        v-if="quizSpelling"
        slot="center"
        align-center
        fill-height
      >
        <slot name="activityTop"></slot>
        <v-layout column justify-center align-center fill-height style="max-height: 65%;">
          <h4
            v-html="phraseTextComputed || ''"
            :class="'activity-phrase ' + $store.state.phraseClass
            + ($vuetify.breakpoint.xs ? ' headline' : ' display-1')"
            style="min-height: 60%;"
            :dir="$store.getters.lLangRtl ? 'rtl' : 'ltr'"
          ></h4>
          <slot name="spelling"></slot>
        </v-layout>
      </v-layout>
      <v-layout
        v-if="quizTranslation"
        slot="center"
        align-center
        fill-height
      >
        <slot name="activityTop"></slot>
        <v-layout column justify-center align-center fill-height style="max-height: 65%;">
          <slot name="translation"></slot>
          <h4
            v-html="nativePhrasesMode ? nativeComputed : phraseTextComputed"
            :class="'activity-phrase ' + $store.state.phraseClass
            + ($vuetify.breakpoint.xs ? ' title' : ' headline')"
            style="min-height: 20%;"
            :dir="$store.getters.lLangRtl ? 'rtl' : 'ltr'"
          ></h4>
        </v-layout>
      </v-layout>
      <v-layout
        v-if="pictoGrid"
        slot="center"
        justify-center
        align-center
        style="height: 100%;"
      >
        <slot name="activityTop"></slot>
        <transition name="component-fade" appear mode="out-in">
          <v-container v-show="activityReady" fluid pa-2 v-bind="{ [`grid-list-md`]: true }">
            <v-layout row wrap>
              <v-flex
                xs6
                v-for="n in pictoGridItems.length"
                :key="n"
                :style="'max-height:' + (pictoGridImageHeight + 32) + 'px'"
              >
                <v-card
                  flat
                  tile
                  :style="pictoGridImageStyle(n)"
                >
                  <img
                    v-if="!$store.getters.isSignLang"
                    width="10px"
                    height="10px"
                    v-show="false"
                    :src="pictoGridImage(n)"
                    alt=""
                    @load="setPictoGridImageReady"
                    @error="setPictoGridImageReady"
                  />
                  <accessible-button
                    :ref="'gridButton' + n"
                    notActive
                    :label="pictoGridItems[n - 1] ? pictoGridItems[n - 1].native_word : ''"
                    style="height: 100%;"
                    @click.native="onPictoGridImage(n)"
                  >
                    <v-container
                      v-if="$store.getters.isSignLang"
                      pa-0
                      :style="'max-width: ' + pgActivityPlayerWidth + 'px;'"
                      justify-center align-center
                    >
                      <video
                        :id="'pgActivityPlayer' + n"
                        class="video-js vjs-default-skin vjs-fluid"
                        crossorigin="use-credentials"
                        playsinline muted
                        :width="pgActivityPlayerWidth" :height="pictoGridImageHeight"
                      ></video>
                    </v-container>
                    <v-img
                      v-else
                      :src="pictoGridImage(n)"
                      :height="pictoGridImageHeight"
                      contain
                    >
                        <span
                          :class="$store.state.phraseClass + ' subheading activity-phrase'"
                          style="position: absolute; top: 64%; left: 0%;"
                          @click="onPictoGridPhrase($event, n)"
                        >
                          {{ pictoGridPhrase(n) }}
                        </span>
                    </v-img>
                  </accessible-button>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </transition>
        <h4
          v-html="phraseTextComputed"
          :class="$store.state.phraseClass + ' headline activity-phrase'"
          :style="'position: absolute; bottom: 0%; left: 0px; z-index: 15;'"
        ></h4>
      </v-layout>
      <v-layout
        v-else-if="!quizWithCustomActions"
        slot="center"
        :align-end="alignEnd"
        :fill-height="!isNote"
        :justify-center="!isNote"
      >
        <slot name="activityTop"></slot>
        <slot name="activityCenter">
          <accessible-button
            v-show="phraseTextComputed !== '' && phraseTextComputed !== undefined"
            :label="phraseTextComputed || ''"
            :style="phrasePosition"
            notActive
            @click.native="onPhrase"
          >
            <h4
              v-html="phraseTextComputed"
              :class="$store.state.phraseClass + phraseSize + ' activity-phrase'"
            ></h4>
          </accessible-button>
          <accessible-button
            v-if="drillFlashcards"
            v-show="phoneticComputed !== '' && phoneticComputed !== undefined"
            :label="phoneticComputed || ''"
            style="width: 100%; top: 44%; position: absolute; z-index: 15; left: 0px;"
            notActive
            @click.native="onPhonetic"
          >
            <h6
              v-html="phoneticComputed"
              :class="$store.state.phraseClass + ' title activity-phrase'"
            ></h6>
          </accessible-button>
          <accessible-button
            v-show="nativeComputed !== '' && nativeComputed !== undefined"
            :label="nativeComputed || ''"
            :style="nativePosition"
            notActive
            @click.native="onNative"
          >
            <h5
              v-html="nativeComputed"
              :class="$store.state.phraseClass + phraseNativeSize + ' activity-phrase'"
            ></h5>
          </accessible-button>
        </slot>
      </v-layout>
      <v-layout
        slot="noAutoplay"
        v-show="showNoAutoplayStartButton"
        justify-center align-center
        style="width: 100%; position: absolute; z-index: 4; top: 12px;"
      >
        <v-btn
          color="primary"
          dark
          :aria-label="$store.state.tr.Play"
          @click="onNoAutoplayStartPlayManually"
          dir="auto"
        > {{ $store.state.tr.Play }} </v-btn>
      </v-layout>
      <!-- <v-tooltip
        slot="afterCard"
        :disabled="!($vuetify.breakpoint.mdAndUp && showNextButton)"
        top
      >
        <right-btn
          v-show="(!wideActivity && $vuetify.breakpoint.mdAndUp)
          || (wideActivity && $vuetify.breakpoint.lgAndUp)"
          slot="activator"
          :style="showNextButton ? 'opacity: 1;'
          : 'visibility: hidden; opacity: 0; transition: none !important'"
          :aria-label="nextButtonLabel"
          @click.native="onNext"
        ></right-btn>
        <span dir="auto">{{ nextButtonLabel }}</span>
      </v-tooltip>
      <v-container
        slot="bottomRightAction"
        v-show="genderVisible && genderIconPossible"
        pa-0 ma-0
        style="max-width: 45px;"
      >
        <transition name="slide-up-fade">
          <v-container pa-0 v-show="genderArticlesOpened">
            <v-tooltip
              v-if="phrase.definite && phrase.definite !== '' && phrase.definite !== 'N/A'"
              left
            >
              <accessible-button
                slot="activator"
                :label="phrase.definite"
                @click.native="onArticle('d')"
              >
                <v-img
                  contain
                  height="45"
                  alt=""
                  :src="genderIconBack"
                >
                  <v-container pa-0 fill-height>
                    <v-layout justify-center align-center fill-height>
                      <span class="body-2 white--text">{{ phrase.definite }}</span>
                    </v-layout>
                  </v-container>
                </v-img>
              </accessible-button>
              <span dir="auto">{{ $store.state.tr.ArticleDefinite }}</span>
            </v-tooltip>
            <v-tooltip
              v-if="phrase.indefinite && phrase.indefinite !== '' && phrase.indefinite !== 'N/A'"
              left
            >
              <accessible-button
                slot="activator"
                :label="phrase.indefinite"
                @click.native="onArticle('i')"
              >
                <v-img
                  contain
                  height="45"
                  alt=""
                  :src="genderIconBack"
                >
                  <v-container pa-0 fill-height>
                    <v-layout justify-center align-center fill-height>
                      <span class="body-2 white--text">{{ phrase.indefinite }}</span>
                    </v-layout>
                  </v-container>
                </v-img>
              </accessible-button>
              <span dir="auto">{{ $store.state.tr.ArticleIndefinite }}</span>
            </v-tooltip>
            <v-tooltip
              v-if="phrase.partitive && phrase.partitive !== '' && phrase.partitive !== 'N/A'"
              left
            >
              <accessible-button
                slot="activator"
                :label="phrase.partitive"
                @click.native="onArticle('p')"
              >
                <v-img
                  contain
                  height="45"
                  alt=""
                  :src="genderIconBack"
                >
                  <v-container pa-0 fill-height>
                    <v-layout justify-center align-center fill-height>
                      <span class="body-2 white--text">{{ phrase.partitive }}</span>
                    </v-layout>
                  </v-container>
                </v-img>
              </accessible-button>
              <span dir="auto">{{ $store.state.tr.ArticlePartitive }}</span>
            </v-tooltip>
          </v-container>
        </transition>
        <v-tooltip
          left
        >
          <accessible-button
            slot="activator"
            :label="genderText"
            @click.native="onGender"
          >
            <v-img
              height="45"
              alt=""
              :src="genderIcon"
            >
              <v-container pa-0 fill-height>
                <v-layout justify-center align-center fill-height>
                  <span class="body-2 white--text">{{ ' ' }}</span>
                </v-layout>
              </v-container>
            </v-img>
          </accessible-button>
          <span dir="auto">{{ genderText }}</span>
        </v-tooltip>
      </v-container>-->
    </pro-card>
    <v-row
      v-if="!((micActivity || cameraActivity) && !deviceEnabled)
      && !drillCompleted && !quizCompleted && activityReady"
      class="component-maxwidth"
      style="min-height: 42px;"
    >
      <!-- <flat-left-btn
        :noLabel="true"
        v-show="$vuetify.breakpoint.smAndDown || (wideActivity && $vuetify.breakpoint.mdAndDown)"
        :class="$store.getters.mx3Nav"
        :style="activityReady && showPrevButton ? 'opacity: 1;' : 'visibility: hidden; opacity: 0;'"
        :aria-label="prevButtonLabel"
        @click.native="onPrev"
      ></flat-left-btn> -->
      <v-layout
        v-if="(showPhraseNumberDisplaySelectable || showPhraseNumberDisplay)"
        class="ml-3"
        row
        :style="'max-width: 145px;' + (phraseNumberDisplayClickable ? 'cursor: pointer;' : '')
        + (isRapidTest ? 'visibility: hidden;' : '')"
      >
        <accessible-button
          :tabindex="showPhraseNumberDisplaySelectable ? '0' : '-1'"
          :label="(activityIndex + 1) + '/' + (quizMode ? activityDataLength : activityDataLength)"
          :style="showPhraseNumberDisplaySelectable ? '' : 'cursor: default !important'"
          @click.native="onPhraseNumberChange"
        >
          <v-icon
            v-if="phraseNumberDisplayClickable"
            dark
            :class="(($vuetify.breakpoint.xs && !$store.getters.isLandscape)
            || $store.getters.isSignLang) ? 'small' : 'medium'"
          >
            arrow_drop_down
          </v-icon>
          <span
            :class="((($vuetify.breakpoint.xs && !$store.getters.isLandscape)
            || $store.getters.isSignLang) ? 'subheading' : 'title') + ' white--text pt-1'"
            :style="!reviewPrevious ? 'opacity: 1;'
            : 'visibility: hidden; opacity: 0; transition: none !important'"
          >
            {{ activityIndex + 1 }} / {{ quizMode ? activityDataLength : activityDataLength }}
          </span>
        </accessible-button>
      </v-layout>
      <v-btn
        v-if="!drillFlashcards && !isRapidTest"
        v-show="phrase && phrase.phonetic && phrase.phonetic !== ''"
        icon
        :outlined="$store.state.user.phoneticMode"
        :color="$store.state.user.phoneticMode ? 'primary' : ''"
        class="mx-1"
        :style="(activityReady ? 'opacity: 1;' : 'visibility: hidden; opacity: 0;')"
        @click.native="onPhoneticMode"
      >
        <v-icon
          :color="$store.state.user.phoneticMode ? 'primary' : 'link'"
          dark
        >
          mdi-translate
        </v-icon>
      </v-btn>
      <slot name="bottomBarLeft"></slot>
      <v-spacer></v-spacer>
      <v-btn
        v-show="normalVisible"
        class="mx-1"
        :style="(normalVisible && showControls && activityReady
        ? 'opacity: 1;' : 'visibility: hidden; opacity: 0;')"
        @click.native="onPlayAudio"
      >
        <v-icon>mdi-refresh</v-icon>
        {{ $store.state.tr.Normal }}
      </v-btn>
      <v-btn
        v-show="slowVisible && !$store.getters.isMediaLevel()"
        class="mx-1"
        :style="(slowVisible && showControls && activityReady
        ? 'opacity: 1;' : 'visibility: hidden; opacity: 0;')"
        @click.native="onPlayAudioSlow"
      >
        <v-icon>mdi-refresh</v-icon>
        {{ $store.state.tr.Slow }}
      </v-btn>
      <!-- <slow-btn
        v-show="slowVisible && !$store.getters.isMediaLevel() && $store.getters.isSignLang"
        :class="'mx-1'"
        plus
        :style="(slowVisible && showControls && activityReady ? 'opacity: 1;'
        : 'visibility: hidden; opacity: 0;')"
        :noLabel="$vuetify.breakpoint.xs"
        @click.native="onPlayAudioSlowPlus"
      ></slow-btn>
      <mute-btn
        v-show="muteVisible"
        :muted="$store.state.user.activityMuted"
        :class="'mx-1'"
        :style="(muteVisible && showControls && activityReady ? 'opacity: 1;'
        : 'visibility: hidden; opacity: 0;')"
        :noLabel="$vuetify.breakpoint.xs"
        @click.native="onMute"
      ></mute-btn> -->
      <slot name="bottomBarCenter"></slot>
      <transition name="component-fade" appear>
        <v-layout
          v-if="(micActivity || cameraActivity) && !isRapidTest"
          class="pa-0"
          row
          :style="(deviceEnabled && isRecording ? 'opacity: 1; max-height: 36px;'
          : 'visibility: hidden; opacity: 0; max-height: 36px;')"
        >
          <v-icon
            v-if="$vuetify.breakpoint.smAndUp && micActivity"
            dark
            medium
          >
            mdi-account-voice
          </v-icon>
          <v-icon
            v-if="micActivity"
            dark
            medium
            color="red"
            class="stroketext"
          >
            mdi-microphone
          </v-icon>
          <v-icon
            v-else
            dark
            medium
            color="red"
            class="stroketext"
          >
            mdi-video
          </v-icon>
          <v-spacer></v-spacer>
        </v-layout>
      </transition>
      <!-- <v-layout
        v-if="showActivityPlayer"
        v-show="$store.getters.isSignLang || showAbcButton"
        class="pa-0"
      >
        <v-btn
          v-if="$store.getters.isSignLang"
          v-show="!cameraActivity && !pictoGrid && !drillFlashcards && !hidePhraseActivity"
          class="pa-0 my-0 mx-1" dark flat
          :icon="$vuetify.breakpoint.smAndDown"
          :style="activityReady ? 'opacity: 1;' : 'visibility: hidden; opacity: 0;'"
          :aria-label="signVideoFront ? 'Front' : 'Side'"
          @click.native="onSignTypeChange"
        >
          <v-icon class="white--text">switch_video</v-icon>
        </v-btn>
        <v-btn
          v-show="showAbcButton"
          class="pa-0 my-0 mx-1" dark flat
          :icon="$vuetify.breakpoint.smAndDown"
          :style="activityReady ? 'opacity: 1;' : 'visibility: hidden; opacity: 0;'"
          :aria-label="$store.state.abcTextVisible ? 'Hide phrases' : 'Show phrases'"
          @click.native="onAbcTextClick"
        >
          <span v-show="$store.state.abcTextVisible" class="white--text">ABC</span>
          <s v-show="!$store.state.abcTextVisible" class="white--text">ABC</s>
        </v-btn>
      </v-layout> -->
      <v-row
        v-if="!drillFlashcards && !isRapidTest"
        class="mx-2"
        :style="activityReady && showNextButton ? 'min-width: 145px; opacity: 1;'
        : 'min-width: 145px; visibility: hidden; opacity: 0;'"
      >
        <v-btn
          class="mx-2 primary"
          @click.native="onNext"
        >
          {{ $store.state.tr.Next }}
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-row>
      <slot name="bottomBarRight"></slot>
      <v-spacer v-show="!$store.getters.isSignLang"></v-spacer>
    </v-row>
    <v-progress-linear
      v-show="recordingStatus !== 0"
      class="mx-2"
      color="red"
      :value="100 - Math.floor(100 * recordingStatus / recordingDuration)"
      :active="isRecording"
    ></v-progress-linear>
  </v-container>
</template>

<script>
/* eslint-disable */

  import BbTools from '@/tools/bluebird'
  import LearningTools from '@/tools/learning'
  import UserTools from '@/tools/user'
  import DeviceAccess from './DeviceAccess'
  import AccessibleButton from '@/components/ui/AccessibleButton'
  import ProCard from '@/components/ui/ProCard'
  import RoutePaths from '@/router/route_paths'
  import RecordRTC from 'recordrtc'
  import videojs from 'video.js'
  import { Howl } from 'howler'

  export default {
    components: {
      'device-access': DeviceAccess,
      'accessible-button': AccessibleButton,
      'pro-card': ProCard,
    },
    props: {
      micActivity: Boolean,
      cameraActivity: Boolean,
      showPhraseNumberDisplaySelectable: Boolean,
      showPhraseNumberDisplay: Boolean,
      navigationVisible: Boolean,
      nextVisible: Boolean, // show next button for quiz-like activities
      normalVisible: Boolean,
      slowVisible: Boolean,
      muteVisible: Boolean,
      hidePhraseActivity: Boolean, // hide phrase for activities like Flashcards if reviewMode is true
      reviewMode: Boolean,
      reviewPrevious: Boolean, // review previous phrase in Vocabulary Coach
      drillCompleted: Boolean,
      alignEnd: Boolean,
      quizMode: Boolean,
      averageScore: Number,
      pictoGrid: Boolean,
      spellingPhrase: String,
      isNote: Boolean, // Notes or QuizQuestion
      videoPlayer: Object,
      nativeAudioMode: Boolean, // play native audio instead of learning audio
      nativePhrasesMode: Boolean,
      videoActivity: Boolean,
      blurImage: Boolean,
      genderVisible: Boolean,
      quizPhrase: Object,
      activityIndex: Number,
      activityDataLength: Number,
      drillPhrase: Object,
    },
    data () {
      return {
        deviceEnabled: true,
        phraseDialog: false,
        activityReady: false,
        activityStarted: false,
        showControls: false,
        audioRepeated: 0,
        activityPlayerRepeated: 0,
        playingPhrase: '',
        timeouts: [],
        audioPlayer: null,
        audioSlowPlayer: null,
        articlePlayer: null,
        deviceRecorder: null,
        isRecording: false,
        recordingStatus: 0,
        recordingDuration: 0,
        recordingInterval: 0,
        quizCompleted: false,
        courseCompleted: false,
        pictoGridItems: [],
        pictoGridImages: [],
        pictoGridImageHeight: 0,
        pictoGridImagesLoaded: 0,
        movieFrame: '',
        cameraPlayer: null,
        activityPlayer: null,
        preloadPlayer: null,
        pgActivityPlayers: [],
        noAutoplayTimeout: null,
        showNoAutoplayStartButton: false,
        signVideoFront: true,
        cameraPlayerVisible: false,
        genderArticlesOpened: false,
        nextQuestionResponse: null
      }
    },
    mounted () {
      this.activityReady = false
      this.activityStarted = false
      this.courseCompleted = false
    },
    watch: {
      '$store.state.windowHeight' (value) {
        this.$nextTick(this.calculatePictoGridHeight)
      },
      '$store.state.globalVolume' (value) {
        if (this.audioPlayer) {
          this.audioPlayer.volume(value)
        }
        if (this.audioSlowPlayer) {
          this.audioSlowPlayer.volume(value)
        }
        if (this.activityPlayer) {
          this.activityPlayer.volume(value)
        }
        if (this.cameraPlayer) {
          this.cameraPlayer.volume(value)
        }
      }
    },
    computed: {
      isRapidTest () {
        return this.$route.path === RoutePaths.RAPID_TEST
      },
      drillFlashcards () {
        return this.$route.path.startsWith(RoutePaths.DRILL_FLASHCARDS); // || this.$route.path.startsWith(Paths.VIDEOS_FLASHCARDS)
      },
      drillConversation () {
        return false; // fixme ? this.$route.path.startsWith(Paths.DRILLS_CONVERSATION_FEMALE) || this.$route.path.startsWith(Paths.DRILLS_CONVERSATION_MALE)
      },
      drillMovie () {
        return false;
      },
      drillPoetry () {
        return false;
      },
      drillPlay () {
        return false;
      },
      drillMusic () {
        return false;
      },
      quizSpelling () {
        return this.quizPhrase && this.quizPhrase.quizType === LearningTools.QUIZ_SPELLING.id;
      },
      quizTranslation () {
        return this.quizPhrase && (this.quizPhrase.quizType === LearningTools.QUIZ_TRANSLATION1.id || this.quizPhrase.quizType === LearningTools.QUIZ_TRANSLATION2.id);
      },
      quizPhraseMatch () {
        return this.quizPhrase && (this.quizPhrase.quizType === LearningTools.QUIZ_PHRASE_MATCH.id || this.quizPhrase.quizType === LearningTools.QUIZ_PHRASE_MATCH2.id);
      },
      quizWithCustomActions () {
        return this.quizSpelling || this.quizTranslation
      },
      wideActivity () {
        return this.drillConversation || this.drillMovie || this.drillPoetry || this.drillPlay || this.drillMusic
      },
      phrase () {
        let result = this.drillPhrase
        if (this.quizPhraseMatch) {
          result = this.quizPhrase.phrase
        } else if (this.reviewPrevious) {
          // fixme
          result = this.$store.getters.prevPhrase
        } else if (this.quizSpelling) {
          result = {
            ...this.quizPhrase.phrase,
            word: this.spellingPhrase,
            phonetic: this.spellingPhrase,
          }
        } else if (this.quizPhrase) {
          result = this.quizPhrase.phrase
        }
        if (result && (!this.$store.state.lastVisitedPhraseForEmail
          || (this.$store.state.lastVisitedPhraseForEmail
            && this.$store.state.lastVisitedPhraseForEmail.id !== result.id))) {
          this.$store.commit('setLastVisitedPhraseForEmail', {
            id: result.id,
            word: result.word,
            lesson: this.$store.state.lesson?.id,
            screen: this.$route.path,
          });
        }
        return result
      },
      phraseNext () {
        if (this.quizPhraseMatch) {
          return this.quizPhrase.phrase
        } else if (this.reviewPrevious) {
          return this.drillPhrase
        } else if (this.quizWithCustomActions) {
          return this.quizPhrase.phrase
        } else if (this.quizPhrase) {
          return this.quizPhrase.phrase // fixme quiz phrase next
        }
        return this.drillPhrase // fixme drill phrase next
      },
      /* showPrevButton () {
        if (this.drillPoetry || this.drillMusic) {
          return this.$store.getters.allowPrevUnit
        } else {
          return this.navigationVisible && !this.quizMode &&
            (this.$store.getters.allowPrevPhrase || (this.$store.getters.allowPrevUnit && !this.$store.getters.isCC))
        }
      },  */
      showNextButton () {
        if (this.drillPoetry || this.drillMusic) {
          return false;
        } else {
          return this.navigationVisible || this.nextVisible;
        }
      },
      imageComputed () {
        const fakeId = this.phrase ? this.phrase.id : Math.random()
        const emptyImage = 'img/empty.png'
        const emptyImageWithId = 'img/empty.png?' + fakeId
        /* fixme if (this.drillConversation) {
          let conversationObj = this.$store.state.conversationImages.find(image => { return image.id === this.$store.getters.unitId })
          if (!conversationObj) {
            conversationObj = { he: `he1.jpg${BbTools.APP_POSTFIX}`, she: `she1.jpg${BbTools.APP_POSTFIX}` }
          }
          if (this.activityIndex % 2 === 0) {
            return this.$store.getters.CONVERSATION_PREFIX_URL + conversationObj.he + '?' + fakeId
          } else {
            return this.$store.getters.CONVERSATION_PREFIX_URL + conversationObj.she + '?' + fakeId
          }
        } else */ if (this.pictoGrid) {
          return emptyImageWithId + Math.random()
        } else if (this.quizPhraseMatch) {
          this.movieFrame = emptyImage
          return emptyImage
        } else if (this.isNote) {
          return emptyImageWithId + Math.random()
        } else if (this.drillMovie) {
          return emptyImage
        } else if (this.$store.getters.isMovieLevel()) {
          return this.movieFrame
        } else if (this.$store.getters.isPlayLevel() && this.drillPlay) {
          return emptyImage
        } else if (this.$store.getters.isMusicLevel() && this.drillMusic) {
          return emptyImage
        } else if (this.quizPhraseMatch) {
          return emptyImage
        } else if (this.showActivityPlayer) {
          if (this.drillFlashcards) {
            return emptyImageWithId + Math.random()
          } else {
            return emptyImageWithId
          }
        /* } else if (this.$route.path.startsWith(Paths.POSTCARDS)) {
          if (this.$store.getters.postcardsImage) {
            return `${this.$store.getters.POSTCARDS_IMAGES_URL}${this.$store.getters.postcardsImage}${BbTools.APP_POSTFIX}`;
          } else {
            return emptyImageWithId
          } */
        } else {
          if (this.phrase) {
            return this.phrase.word_image ? this.phrase.word_image : emptyImageWithId
          } else {
            return emptyImage
          }
        }
      },
      imageComputedNext () {
        const emptyImage = 'img/empty.png'
        if (this.pictoGrid) {
          return emptyImage
        } else if (this.isNote) {
          return emptyImage
        } else if (this.drillMovie) {
          return emptyImage
        } else if (this.$store.getters.isMovieLevel()) {
          return emptyImage
        } else if (this.$store.getters.isPlayLevel() && this.drillPlay) {
          return emptyImage
        } else if (this.$store.getters.isMusicLevel() && this.drillMusic) {
          return emptyImage
        } else if (this.showActivityPlayer) {
          if (this.drillFlashcards) {
            return emptyImage
          } else {
            return emptyImage
          }
        /* } else if (this.$route.path.startsWith(Paths.POSTCARDS)) {
          if (this.$store.getters.postcardsImage) {
            return this.$store.getters.POSTCARDS_IMAGES_URL + this.$store.getters.postcardsImageNext
          } else {
            return emptyImage
          } */
        } else {
          return this.phraseNext ? this.phraseNext.word_image : emptyImage
        }
      },
      phraseTextComputed () {
        let phraseWord = ''
        if (this.phrase) {
          if (this.showPhonetic) {
            phraseWord = this.phrase.phonetic
          } else {
            phraseWord = this.phrase.word
          }
        }

        if (this.showActivityPlayer && this.showAbcButton) {
          if (!this.$store.state.abcTextVisible) {
            return LearningTools.PHRASE_HIDDEN
          } else if (this.$store.state.hidePhrase) {
            return LearningTools.PHRASE_HIDDEN
          } else {
            return this.playingPhrase || phraseWord
          }
        } else if (this.reviewMode) {
          if (this.hidePhraseActivity) {
            return (phraseWord && phraseWord !== '') ? LearningTools.PHRASE_HIDDEN : ''
          } else {
            return this.playingPhrase || phraseWord
          }
        } else {
          if (!this.quizMode && this.$store.state.hidePhrase) {
            if (this.drillMovie) {
              return (phraseWord && phraseWord !== '' && this.playingPhrase !== '') ? LearningTools.PHRASE_HIDDEN : ''
            } else {
              return (phraseWord && phraseWord !== '') ? LearningTools.PHRASE_HIDDEN : ''
            }
          } else {
            if (this.drillMovie) {
              return (phraseWord && phraseWord !== '') ? this.playingPhrase : ''
            } else {
              return this.playingPhrase || phraseWord
            }
          }
        }
      },
      showPhonetic () {
        return !this.drillFlashcards && this.$store.state.user.phoneticMode
          && this.phrase.phonetic && this.phrase.phonetic !== '';
      },
      phoneticComputed () {
        const phrasePhonetic = this.phrase ? this.phrase.phonetic : ''
        if (this.showActivityPlayer && this.showAbcButton) {
          if (!this.$store.state.abcTextVisible) {
            return LearningTools.PHRASE_HIDDEN
          } else if (this.$store.state.hidePhonetic) {
            return LearningTools.PHRASE_HIDDEN
          } else {
            return phrasePhonetic
          }
        } else if (this.reviewMode) {
          if (this.hidePhraseActivity) {
            return (phrasePhonetic && phrasePhonetic !== '') ? LearningTools.PHRASE_HIDDEN : ''
          } else {
            return phrasePhonetic
          }
        } else {
          if (this.$store.state.hidePhonetic) {
            return (phrasePhonetic && phrasePhonetic !== '') ? LearningTools.PHRASE_HIDDEN : ''
          } else {
            return phrasePhonetic
          }
        }
      },
      nativeComputed () {
        const phraseNative = this.phrase ? this.phrase.native_word : ''
        if (this.showActivityPlayer && this.showAbcButton) {
          if (!this.$store.state.abcTextVisible) {
            return LearningTools.PHRASE_HIDDEN
          } else if (this.$store.state.hideNative) {
            return LearningTools.PHRASE_HIDDEN
          } else {
            return phraseNative
          }
        } else if (!this.quizMode && this.$store.state.hideNative) {
          return (phraseNative && phraseNative !== '') ? LearningTools.PHRASE_HIDDEN : ''
        } else {
          if (this.drillMovie) {
            return (this.phraseTextComputed && this.phraseTextComputed !== '') ? phraseNative : ''
          } else {
            return phraseNative
          }
        }
      },
      phraseSize () {
        if (this.drillMovie) {
          if (this.$vuetify.breakpoint.xs || (this.$vuetify.breakpoint.sm && this.$store.getters.isLandscape)) {
            return ' title'
          } else {
            return ' headline'
          }
        } else {
          if (this.$vuetify.breakpoint.smAndDown) {
            return ' headline'
          } else {
            return ' display-1'
          }
        }
      },
      phraseNativeSize () {
        if (this.drillMovie) {
          if (this.$vuetify.breakpoint.xs) {
            return ' subheading'
          } else {
            return ' title'
          }
        } else {
          return ' headline'
        }
      },
      phrasePosition () {
        let result = 'z-index: 15; position: absolute;'
        if (this.drillMovie) {
          if ((this.$store.state.langI.id === '297' && this.$store.state.langL.id === '1')) {
            result += 'top: 82%; left: 0px;'
          } else {
            result += 'top: 70%; left: 0px;'
          }
          if (this.$vuetify.breakpoint.xs) {
            result += 'width: 95%; left: 2%;'
          } else if (this.$vuetify.breakpoint.sm) {
            result += 'width: 88%; left: 6%;'
          } else {
            result += 'width: 80%; left: 10%;'
          }
        } else {
          result += 'top: 20%; left: 0px; width: 100%;'
        }
        return result
      },
      nativePosition () {
        let result = 'z-index: 15; position: absolute;'
        if (this.drillMovie) {
          if ((this.$store.state.langI.id === '297' && this.$store.state.langL.id === '1')) {
            return 'display: none; '
          } else {
            result += 'top: 86%; left: 0px;'
            if (this.$vuetify.breakpoint.xs) {
              result += 'width: 95%; left: 2%;'
            } else if (this.$vuetify.breakpoint.sm) {
              result += 'width: 88%; left: 6%;'
            } else {
              result += 'width: 80%; left: 10%;'
            }
            return result
          }
        } else {
          return 'z-index: 15; position: absolute; top: 72%; left: 0px; width: 100%;'
        }
      },
      /* prevButtonLabel () {
        if (this.$store.getters.allowPrevUnit && !this.$store.getters.allowPrevPhrase) {
          return this.$store.state.tr.PreviousUnit
        } else {
          return this.$store.state.tr.Previous
        }
      },
      nextButtonLabel () {
        if (this.$store.getters.isCC) {
          if (!this.drillCompleted && !this.quizCompleted && !this.isNote && this.$store.getters.allowNextPhrase(this.quizMode)) {
            return this.$store.state.tr.Next
          } else if (this.$store.getters.nextActivity) {
            return this.$store.state.tr.NextStep
          } else if (this.$store.getters.allowNextUnit) {
            return this.$store.state.tr.NextUnit
          } else if (this.$store.getters.allowNextLevel) {
            return this.$store.state.tr.Next
          } else {
            return this.$store.state.tr.Next
          }
        } else if (this.$store.getters.allowNextUnit && !this.$store.getters.allowNextPhrase(this.quizMode) && !this.quizMode) {
          return this.$store.state.tr.NextUnit
        } else {
          return this.$store.state.tr.Next
        }
      }, */
      phraseNumberDisplayClickable () {
        return false;
        // fixme
        if (this.showPhraseNumberDisplaySelectable) {
          if (this.$store.getters.isCC && this.$store.getters.ccLocked) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      },
      showActivityPlayer () {
        return (!this.isNote && this.$store.getters.isSignLang) || this.videoActivity
      },
      videoActivityWithEmbedAudio () {
        return !this.$store.getters.isSignLang && this.videoActivity
      },
      pgActivityPlayerWidth () {
        let result = Math.round(this.pictoGridImageHeight * (3 / 2))
        if (result < 700 / 2) { // get rid of black bars in Edge

        }
        return result
      },
      activityPlayerWidth () {
        return this.activityPlayerHeight * (3 / 2)
      },
      activityPlayerHeight () {
        return this.$store.getters.activityHeight > 500 ? 500 : this.$store.getters.activityHeight;
      },
      signVideoPathFront () {
        return this.$store.getters.ipLearn + '/files/' + this.$store.state.langL.id + '/mp4/' + this.phrase.id + 'f' + '.mp4' + BbTools.APP_POSTFIX
      },
      signVideoPathSide () {
        return this.$store.getters.ipLearn + '/files/' + this.$store.state.langL.id + '/mp4/' + this.phrase.id + 's' + '.mp4' + BbTools.APP_POSTFIX
      },
      activityVideoPath () {
        return this.$store.getters.ipLearn + '/files/' + this.$store.state.langL.id + '/mp4/' + this.phrase.id + '.mp4' + BbTools.APP_POSTFIX
      },
      signVideoPathFrontNext () {
        return this.$store.getters.ipLearn + '/files/' + this.$store.state.langL.id + '/mp4/' + this.phraseNext.id + 'f' + '.mp4' + BbTools.APP_POSTFIX
      },
      signVideoPathSideNext () {
        return this.$store.getters.ipLearn + '/files/' + this.$store.state.langL.id + '/mp4/' + this.phraseNext.id + 's' + '.mp4' + BbTools.APP_POSTFIX
      },
      activityVideoPathNext () {
        return this.$store.getters.ipLearn + '/files/' + this.$store.state.langL.id + '/mp4/' + this.phraseNext.id + '.mp4' + BbTools.APP_POSTFIX
      },
      showAbcButton () {
        return !this.quizMode && !this.drillFlashcards && !this.hidePhraseActivity && !this.showNoAutoplayStartButton
      },
      genderIcon () {
        if (this.genderIconPossible) {
          return 'img/gender/' + this.phrase.gender + '.png'
        } else {
          return ''
        }
      },
      genderIconBack () {
        if (this.genderIconPossible) {
          return 'img/gender/' + this.phrase.gender + 'b.png'
        } else {
          return ''
        }
      },
      genderText () {
        if (this.genderIconPossible) {
          return this.$store.state.tr['Gender' + this.phrase.gender]
        } else {
          return ''
        }
      },
      genderIconPossible () {
        if (this.phrase && this.phrase.id && this.phrase.gender) {
          const phraseId = parseInt(this.phrase.id)
          if (phraseId >= 1 && phraseId <= 1977) {
            return this.phrase.gender
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },
    methods: {
      startPlaying (rapidTestAnswer) {
        this.pauseAllAudio()
        this.audioRepeated = 0
        this.activityPlayerRepeated = 0
        if (this.$route.query.noPlay || (this.muteVisible && this.$store.state.user.activityMuted)) {
          if (this.activityPlayer) {
            this.initPreloadPlayer()
            this.activityPlayer.playbackRate(1)
            this.activityPlayer.currentTime(0)
            this.activityPlayer.play()
          }
          this.$emit('audioPlayed', this.nextQuestionResponse)
          this.showControls = true
          this.$router.replace({query: {}})
        } else {
          this.playAudio(rapidTestAnswer)
        }
      },
      setPictoGridImageReady () {
        this.pictoGridImagesLoaded ++
        if (this.pictoGridImagesLoaded >= this.pictoGridItems.length) {
          this.pictoGridImagesLoaded = 2
          this.setActivityReady()
        }
      },
      getMovieFrameFromCurrentTime () {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        canvas.width = 985
        canvas.height = 537
        context.drawImage(this.videoPlayer.el_.children[0], 0, 0, canvas.width, canvas.height)
        return canvas.toDataURL()
      },
      movieSeeked () {
        this.movieFrame = this.getMovieFrameFromCurrentTime()
      },
      async movieSeekedForPictoGrid () {
        await BbTools.sleepCancelable(100, this.$store)
        this.pictoGridImages.push(this.getMovieFrameFromCurrentTime())
        if (this.pictoGridImages.length < this.pictoGridItems.length) {
          await BbTools.sleepCancelable(100, this.$store)
          this.videoPlayer.one('seeked', this.movieSeekedForPictoGrid)
          this.videoPlayer.currentTime(this.pictoGridItems[this.pictoGridImagesLoaded].startTime + 0.4)
        }
      },
      async setActivityReady (event, doNotInitActivityPlayer) {
        this.quizCompleted = false
        this.cameraPlayerVisible = false
        if (!this.showActivityPlayer) {
          this.disposeActivityPlayers()
        }
        if (this.pictoGrid && this.pictoGridImagesLoaded !== 2) { // current phrase fake image loaded, now generate images for pictoGrid
          this.disposeActivityPlayers()
          this.pictoGridImagesLoaded = 0
          this.pictoGridItems = []
          this.pictoGridImages = []
          await BbTools.sleepCancelable(100, this.$store) // let img-tags be updated to empty
          const pictoGridItems = []
          this.quizPhrase.choices.forEach(item => pictoGridItems.push({ ...item }))
          this.pictoGridItems = pictoGridItems;
          // this.pictoGridItems.forEach
          if (this.showActivityPlayer) {
            await BbTools.sleepCancelable(100, this.$store)
            this.pictoGridItems.forEach((item, index) => {
              const sources = [{
                type: 'video/mp4',
                src: this.$store.getters.ipLearn + '/files/' + this.$store.state.langL.id + '/mp4/' + item.id + 'f' + '.mp4' + BbTools.APP_POSTFIX
              }]
              const pgActivityPlayer = videojs('pgActivityPlayer' + (index + 1), {
                techOrder: ['html5'],
                width: this.pgActivityPlayerWidth,
                height: this.pictoGridImageHeight,
                controls: false,
                nativeControlsForTouch: false,
                playsinline: true,
                muted: true,
                preload: true,
                autoplay: true,
                loop: true,
                sources: sources
              })
              pgActivityPlayer.on('loadeddata', this.onPgActivityPlayerStartLoad)
              pgActivityPlayer.on('playing', this.onActivityPlayerStartPlay)
              pgActivityPlayer.on('touchstart', () => this.onPictoGridImage(index + 1))
              this.pgActivityPlayers.push(pgActivityPlayer)
            })
            if (this.noAutoplayTimeout) {
              clearTimeout(this.noAutoplayTimeout)
            }
            this.noAutoplayTimeout = setTimeout(this.activityPlayerAutoplayTimeoutEnd, BbTools.TO_VIDEO_LOADING)
          }
          return
        } else { // all pictoGrid images are loaded or not pictoGrid
          if (this.showActivityPlayer && !doNotInitActivityPlayer) {
            this.showNoAutoplayStartButton = false
            let sources
            if (this.$store.getters.isSignLang) {
              sources = [{
                type: 'video/mp4',
                src: this.signVideoFront ? this.signVideoPathFront : this.signVideoPathSide
              }]
            } else {
              sources = [{
                type: 'video/mp4',
                src: this.activityVideoPath
              }]
            }
            if (this.activityPlayer) {
              this.activityPlayer.src(sources)
            } else {
              this.activityPlayer = videojs('activityPlayer', {
                techOrder: ['html5'],
                width: this.activityPlayerWidth,
                height: this.activityPlayerHeight,
                controls: false,
                playsinline: true,
                muted: this.$store.getters.isSignLang,
                autoplay: true,
                preload: true,
                userActive: false,
                sources: sources
              })
              this.activityPlayer.on('ended', this.onActivityPlayerEnd)
              this.activityPlayer.on('loadeddata', this.onActivityPlayerLoad)
              if (this.$store.getters.iOS) {
                // doesn't work properly on iOS devices
              } else {
                this.activityPlayer.on('playing', this.onActivityPlayerStartPlay)
              }
            }
            this.activityPlayer.volume(this.$store.state.globalVolume)
            if (this.noAutoplayTimeout) {
              clearTimeout(this.noAutoplayTimeout)
            }
            this.noAutoplayTimeout = setTimeout(this.activityPlayerAutoplayTimeoutEnd, LearningTools.TO_VIDEO_LOADING)
            return
          } else if (this.$store.getters.isMovieLevel() && !this.drillMovie && this.pictoGrid) {
            if (this.pictoGridImages.length === 0) {
              this.pictoGridImagesLoaded = 0
              this.videoPlayer.one('seeked', this.movieSeekedForPictoGrid)
              this.videoPlayer.currentTime(this.pictoGridItems[0].startTime + 0.4)
              return
            }
          } else if (this.$store.getters.isMovieLevel() && !this.drillMovie && this.movieFrame === '') {
            // if not DrillsMovie - wait for movie frame as phrase picture
            if (!this.activityReady) {
              if (this.videoPlayer) {
                this.videoPlayer.one('seeked', this.movieSeeked)
                this.videoPlayer.currentTime(this.phrase.startTime + 0.4)
              }
            }
            return
          }
          this.pictoGridImagesLoaded = 0
          this.activityStarted = true
          this.activityReady = true
          this.playingPhrase = ''
          this.stopActivity()
          this.$nextTick(this.calculatePictoGridHeight)
          if (!this.$store.state.user.activityMuted) {
            await BbTools.sleepCancelable(LearningTools.TO_START_PLAYING, this.$store)
          }
          this.$nextTick(this.calculatePictoGridHeight)
          if (this.activityReady) { // prevent from playing previous phrase
            this.$emit('activityReady')
            if (this.pictoGrid) { // focus on pictoGrid
              const n = '1'
              if (this.$refs['gridButton' + n] && this.$refs['gridButton' + n][0] && this.$refs['gridButton' + n][0].$el) {
                this.$refs['gridButton' + n][0].$el.focus()
              }
            }
          }
        }
      },
      onPgActivityPlayerStartLoad () {
        this.showNoAutoplayStartButton = false
        this.pictoGridImagesLoaded ++
        if (this.pictoGridImagesLoaded >= this.pictoGridItems.length) {
          this.pictoGridImagesLoaded = 2
          this.setActivityReady(null, true)
        }
      },
      onActivityPlayerLoad () {
        // video must be visible on stage to be played
        this.activityReady = true
      },
      onActivityPlayerStartPlay () {
        this.showNoAutoplayStartButton = false
        if (!this.activityStarted) {
          this.setActivityReady(null, true)
        }
      },
      onNoAutoplayStartPlayManually () {
        this.showNoAutoplayStartButton = false
        if (this.showActivityPlayer && this.activityPlayer) {
          if (!this.activityStarted) {
            this.setActivityReady(null, true)
          } else {
            if (this.pictoGrid) {
              this.pgActivityPlayers.forEach(player => {
                player.currentTime(0)
                player.play()
              })
            } else if (this.activityPlayer) {
              this.playAudio()
              /* fixme
              if (this.quizPhrase.quizType === LearningTools.QUIZ_VOCABULARY.id) {
                this.playActivityPlayerOnly()
              } else {
                this.playAudio()
              } */
            }
          }
        } else if (this.audioPlayer) {
          this.audioPlayer.play()
        }
      },
      playActivityPlayerOnly () {
        this.initPreloadPlayer()
        this.activityPlayer.playbackRate(1)
        this.activityPlayer.currentTime(0)
        this.activityPlayer.play()
      },
      activityPlayerAutoplayTimeoutEnd () {
        this.noAutoplayTimeout = null
        if ((this.pictoGrid && this.pictoGridImagesLoaded === 0) ||
          (!this.pictoGrid && !this.showNoAutoplayStartButton)) { // it seems that video autoplay doesn't work
          if (!this.activityStarted) {
            this.showNoAutoplayStartButton = true
            if (!this.activityReady) {
              this.activityReady = true
            }
          }
        }
      },
      audioPlayerAutoplayTimeoutEnd () {
        this.noAutoplayTimeout = null
        if (!this.showNoAutoplayStartButton) { // it seems that audio autoplay doesn't work
          this.showNoAutoplayStartButton = true
        }
      },
      disableAudioRepeat () {
        this.audioRepeated = 5
        this.activityPlayerRepeated = 5
      },
      onPlayAudio () {
        this.disableAudioRepeat()
        this.playAudio()
      },
      onPlayAudioSlow () {
        this.disableAudioRepeat()
        this.playAudioSlow()
      },
      onPlayAudioSlowPlus () {
        this.disableAudioRepeat()
        this.playAudioSlow(true)
      },
      async playAudio (rapidTestAnswer) {
        this.cameraPlayerVisible = false
        this.pauseAllAudio()
        if (this.$store.getters.isMediaLevel()) {
          if (this.videoPlayer) {
            this.videoPlayer.currentTime(this.phrase.startTime)
            this.videoPlayer.on('timeupdate', this.onVideoTimeUpdate)
            this.videoPlayer.play()
            this.createWordColoring()
          }
        } else {
          if (this.audioPlayer) this.audioPlayer.unload()
          if (this.videoActivityWithEmbedAudio) {
            this.audioPlayer = null
            this.onAudioLoad()
          } else {
            let src = ''
            if (this.isRapidTest && rapidTestAnswer) {
              src = rapidTestAnswer.path_to_audio;
            } else {
              src = this.nativeAudioMode
                ? (this.phrase.audio_native || this.phrase.audio) : this.phrase.audio
            }
            this.audioPlayer = new Howl({
              src: [src],
              volume: this.$store.state.globalVolume,
              onload: this.onAudioLoad,
              onend: this.onAudioEnd,
              onplay: () => {
                clearTimeout(this.noAutoplayTimeout)
                this.noAutoplayTimeout = null
                this.showNoAutoplayStartButton = false
              }
            })
          }
        }
      },
      async onAudioLoad () {
        if (this.activityPlayer) {
          this.activityPlayer.playbackRate(1)
          this.activityPlayer.currentTime(0)
          this.activityPlayer.play()
          if (this.$store.getters.isSignLang && this.audioPlayer && this.activityPlayer.duration() > this.audioPlayer.duration()) {
            await BbTools.sleepCancelable(LearningTools.TO_START_PLAYING, this.$store)
          } else if (this.videoActivityWithEmbedAudio) {
            this.createWordColoring()
          }
        }
        this.initPreloadPlayer()
        if (this.audioPlayer) {
          this.audioPlayer.play()
          this.createWordColoring()
          if (this.noAutoplayTimeout) {
            clearTimeout(this.noAutoplayTimeout)
          }
          this.noAutoplayTimeout = setTimeout(this.audioPlayerAutoplayTimeoutEnd, LearningTools.TO_AUDIO_START)
        }
      },
      initPreloadPlayer () {
        if (this.showActivityPlayer & !this.pictoGrid) {
          let sourcesPreload
          if (this.$store.getters.isSignLang) {
            sourcesPreload = [{
              type: 'video/mp4',
              src: this.signVideoFront ? this.signVideoPathFrontNext : this.signVideoPathSideNext
            }]
          } else {
            sourcesPreload = [{
              type: 'video/mp4',
              src: this.activityVideoPathNext
            }]
          }
          if (this.preloadPlayer) {
            if (this.preloadPlayer.currentSrc() !== sourcesPreload[0].src) {
              this.preloadPlayer.src(sourcesPreload)
            }
          } else {
            this.preloadPlayer = videojs('preloadPlayer', {
              techOrder: ['html5'],
              width: this.activityPlayerWidth,
              height: this.activityPlayerHeight,
              controls: false,
              playsinline: true,
              muted: true,
              autoplay: false,
              preload: true,
              sources: sourcesPreload
            })
          }
        }
      },
      createWordColoring (nativeDuration, phraseNative) {
        if (this.nativeAudioMode) {
          return
        }
        let phraseDuration = 0
        let changePlayingPhraseFunction = this.changePlayingPhrase
        let phrase = this.showPhonetic ? this.phrase.phonetic : this.phrase.word
        if (nativeDuration) { // poetry drill
          phraseDuration = nativeDuration
          changePlayingPhraseFunction = this.changePlayingPhraseNative
          phrase = phraseNative
        } else if (this.$store.getters.isMediaLevel()) {
          phraseDuration = this.phrase.fragmentLength * 1000
          if (this.$store.getters.isMovieLevel()) {
            phraseDuration -= 200
            if (phraseDuration < 300) {
              phraseDuration += 200
            }
          }
        } else if (this.videoActivityWithEmbedAudio) {
          phraseDuration = this.activityPlayer.duration() * 1000 - 500
          if (phraseDuration < 200) {
            phraseDuration += 300
          }
        } else {
          phraseDuration = this.audioPlayer.duration() * 1000
        }
        LearningTools.getPhraseWords(phrase, phraseDuration, this.$store).forEach((key, value) => {
          this.timeouts.push(setTimeout(changePlayingPhraseFunction, key, value))
        })
      },
      onVideoTimeUpdate () {
        if (this.videoPlayer) {
          if (this.videoPlayer.currentTime() >= this.phrase.endTime) {
            this.pauseVideo()
            this.onAudioEnd()
          }
        }
      },
      pauseVideo () {
        if (this.videoPlayer) {
          this.videoPlayer.pause()
          this.videoPlayer.off('timeupdate', this.onVideoTimeUpdate)
        }
      },
      pauseActivityPlayer () {
        if (this.activityPlayer) {
          this.activityPlayer.pause()
        }
      },
      async playAudioSlow (slowPlus = false) {
        this.pauseAllAudio()
        const callback = slowPlus ? this.onAudioSlowLoadPlus : this.onAudioSlowLoad
        if (this.videoActivityWithEmbedAudio) {
          callback()
          return
        }
        const slowSources = [{
          type: 'audio/mp3',
          src: this.phrase.audio
        }]
        if (this.audioSlowPlayer) {
          if (this.audioSlowPlayer.currentSrc() !== slowSources[0].src) {
            this.audioSlowPlayer.src(slowSources)
            this.audioSlowPlayer.load()
          } else {
            callback()
          }
        } else {
          this.audioSlowPlayer = videojs('slowPlayer', {
            techOrder: ['html5'],
            width: 150,
            height: 150,
            controls: false,
            playsinline: true,
            muted: false,
            autoplay: false,
            preload: true,
            sources: slowSources
          })
          this.audioSlowPlayer.on('loadeddata', callback)
          this.audioSlowPlayer.volume(this.$store.state.globalVolume)
        }
      },
      async onAudioSlowLoad () {
        let text = this.showPhonetic ? this.phrase.phonetic : this.phrase.word
        if (this.showActivityPlayer && this.activityPlayer) {
          this.activityPlayer.playbackRate(0.6)
          this.activityPlayer.currentTime(0)
          this.activityPlayer.play()
          if (!this.$store.getters.isSignLang && !this.audioSlowPlayer) {
            if (this.audioPlayer && this.activityPlayer.duration() > this.audioPlayer.duration()) {
              await BbTools.sleepCancelable(LearningTools.TO_START_PLAYING / 0.6, this.$store)
            }
            LearningTools.getPhraseWords(text, this.activityPlayer.duration() * 1000 / 0.6, this.$store)
              .forEach((key, value) => {
                this.timeouts.push(setTimeout(this.changePlayingPhrase, key, value))
              })
          }
        }
        if (this.audioSlowPlayer && !this.$store.getters.isSignLang) {
          this.audioSlowPlayer.currentTime(0)
          this.audioSlowPlayer.playbackRate(0.5)
          this.audioSlowPlayer.play()
          LearningTools.getPhraseWords(text, this.audioSlowPlayer.duration() * 1000 / 0.5, this.$store)
            .forEach((key, value) => {
              this.timeouts.push(setTimeout(this.changePlayingPhrase, key, value))
            })
        }
      },
      async onAudioSlowLoadPlus () {
        let text = this.showPhonetic ? this.phrase.phonetic : this.phrase.word
        if (this.showActivityPlayer && this.activityPlayer) {
          this.activityPlayer.playbackRate(0.3)
          this.activityPlayer.currentTime(0)
          this.activityPlayer.play()
          if (!this.$store.getters.isSignLang && !this.audioSlowPlayer) {
            if (this.audioPlayer && this.activityPlayer.duration() > this.audioPlayer.duration()) {
              await BbTools.sleepCancelable(LearningTools.TO_START_PLAYING / 0.3, this.$store)
            }
            LearningTools.getPhraseWords(text, this.activityPlayer.duration() * 1000 / 0.3, this.$store)
              .forEach((key, value) => {
                this.timeouts.push(setTimeout(this.changePlayingPhrase, key, value))
              })
          }
        }
        if (this.audioSlowPlayer && !this.$store.getters.isSignLang) { // never happens: slow+ only for isSignLang
          this.audioSlowPlayer.currentTime(0)
          this.audioSlowPlayer.playbackRate(0.25)
          this.audioSlowPlayer.play()
          LearningTools.getPhraseWords(text, this.audioSlowPlayer.duration() * 1000 / 0.25, this.$store)
            .forEach((key, value) => {
              this.timeouts.push(setTimeout(this.changePlayingPhrase, key, value))
            })
        }
      },
      changePlayingPhrase (str) {
        this.$emit('playingPhrase', str)
        this.playingPhrase = str
      },
      changePlayingPhraseNative (str) {
        this.$emit('playingPhraseNative', str)
      },
      pauseAllAudio () {
        this.clearTimeouts()
        this.pauseAudio()
        this.pauseSlowAudio()
        this.pauseArticleAudio()
        this.pauseVideo()
        this.pauseActivityPlayer()
      },
      pauseAudio () {
        this.clearTimeouts()
        if (this.audioPlayer) this.audioPlayer.stop()
      },
      pauseSlowAudio () {
        this.clearTimeouts()
        if (this.audioSlowPlayer) this.audioSlowPlayer.pause()
      },
      pauseArticleAudio () {
        if (this.articlePlayer) this.articlePlayer.pause()
      },
      clearTimeouts () {
        this.playingPhrase = ''
        this.timeouts.forEach(function (item) {
          clearTimeout(item)
        })
        this.timeouts = []
      },
      async stopActivity () {
        this.$emit('activityStopped')
        this.audioRepeated = -1
        this.activityPlayerRepeated = -1
        this.clearTimeouts()
        this.pauseAllAudio()
        this.releaseDevice()
        this.playingPhrase = ''
        if (this.audioPlayer) this.audioPlayer.unload()
        if (this.audioSlowPlayer) this.audioSlowPlayer.pause()
        this.isRecording = false
        this.recordingStatus = 0
        clearInterval(this.recordingInterval)
      },
      /* decreaseCurrPage () {
        this.movieFrame = ''
        this.$store.commit('decreaseCurrPage')
      },
      incrementCurrPage () {
        this.movieFrame = ''
        this.$store.commit('incrementCurrPage')
        this.$emit('next')
      }, */
      onNext () {
        this.stopActivity()
        this.activityReady = false
        this.$emit('next')
      },
      onRepeatCameraPlayerEnd () {
        this.$emit('recordPlayed')
      },
      onActivityPlayerEnd () {
        this.activityPlayerRepeated++
        if (this.videoActivityWithEmbedAudio) {
          this.audioRepeated++
          this.activityPlayed()
        } else if (this.$store.getters.isSignLang) {
          if (this.activityPlayerRepeated === this.audioRepeated) {
            this.activityPlayed()
          }
        } else {
          this.activityPlayed()
        }
      },
      onAudioEnd () {
        this.playingPhrase = ''
        this.audioRepeated++
        if (this.showActivityPlayer && !this.pictoGrid) {
          if (this.activityPlayerRepeated === this.audioRepeated) {
            this.activityPlayed()
          }
        } else {
          this.activityPlayed()
        }
      },
      async activityPlayed () {
        this.showNoAutoplayStartButton = false
        await BbTools.sleepCancelable(LearningTools.TO_START_PLAYING, this.$store)
        if (this.audioRepeated !== -1) { // if activity has not been stopped during sleep
          if (!this.drillPoetry && this.audioRepeated < this.$store.state.user.repeatNumber) {
            this.playAudio()
          } else {
            this.showControls = true
            this.$emit('audioPlayed', this.nextQuestionResponse)
          }
        }
      },
      async recordDevice () {
        if (this.cameraActivity) {
          if (this.activityPlayer) {
            this.activityPlayer.autoplay(false) // to prevent autoplay after accessing devices on iOS
          }
          if (this.videoActivityWithEmbedAudio) {
            if (this.cameraActivity && this.$store.getters.iOS) {
              LearningTools.captureDevice(navigator, { video: true, audio: false }, this.deviceSuccessCallback, this.deviceErrorCallback)
            } else {
              LearningTools.captureDevice(navigator, { video: true, audio: true }, this.deviceSuccessCallback, this.deviceErrorCallback)
            }
          } else {
            LearningTools.captureDevice(navigator, { video: true, audio: false }, this.deviceSuccessCallback, this.deviceErrorCallback)
          }
        } else {
          LearningTools.captureDevice(navigator, { video: false, audio: true }, this.deviceSuccessCallback, this.deviceErrorCallback)
        }
      },
      async deviceSuccessCallback (stream) {
        let recordingDuration = (parseInt(this.phrase.length) + 2) * 1000
        if (this.cameraActivity) {
          if (!this.deviceRecorder) {
            this.deviceRecorder = RecordRTC(stream, {
              type: 'video',
              recorderType: RecordRTC.MediaStreamRecorder,
              // mimeType: 'video/webm\\;codecs=h264',
              mimeType: 'video/mp4',
              disableLogs: true
            })
          }
          if (this.activityPlayer) {
            recordingDuration = this.activityPlayer.duration() * 1000 + 1500
            this.activityPlayer.autoplay(true)
          }
        } else {
          if (!this.deviceRecorder) {
            this.deviceRecorder = RecordRTC(stream, {
              type: 'audio',
              recorderType: RecordRTC.StereoAudioRecorder,
              mimeType: 'audio/wav',
              disableLogs: true,
              sampleRate: 44100,
              bufferSize: 4096,
              numberOfAudioChannels: 2
            })
          }
        }
        this.deviceRecorder.clearRecordedData()
        this.deviceRecorder.stream = stream
        this.isRecording = true
        this.recordingStatus = 0
        clearInterval(this.recordingInterval)
        if (this.cameraActivity) {
          this.initCameraPlayer(stream, true)
        }
        this.$beepPlayer.play()
        await BbTools.sleepCancelable(LearningTools.TO_START_RECORDING, this.$store)
        try {
          this.recordingDuration = recordingDuration;
          this.recordingInterval = setInterval(this.recordingIntervalHandle, 100);
          if (this.cameraActivity && this.$store.getters.iOS) {
            // fixme: MediaRecorder is now an experimental feature in Safari
            setTimeout(this.iOSRecordingStopped, recordingDuration)
          } else {
            this.deviceRecorder.startRecording()
            setTimeout(this.stopRecording, recordingDuration)
          }
        } catch (err) {
          alert(err + ' ! ' + err.message)
        }
      },
      recordingIntervalHandle() {
        this.recordingStatus += 100
      },
      deviceErrorCallback (error) {
        this.deviceEnabled = false
        if (error && error.message) {
          alert(error.message)
        }
      },
      async stopRecording () {
        this.isRecording = false
        this.recordingStatus = 0
        clearInterval(this.recordingInterval)
        if (this.deviceRecorder) {
          await this.deviceRecorder.stopRecording(this.recordingStopped)
        }
      },
      async iOSRecordingStopped () {
        this.isRecording = false
        this.recordingStatus = 0
        clearInterval(this.recordingInterval)
        this.cameraPlayerVisible = false
        await this.releaseDevice()
        this.$emit('deviceRecorded', null)
      },
      async recordingStopped (dataURL) {
        this.cameraPlayerVisible = false
        if (this.cameraActivity) {
          const sources = [{
            type: 'video/mp4',
            src: this.deviceRecorder.toURL()
          }]
          this.$emit('deviceRecorded', sources)
        } else {
          if (this.deviceRecorder) {
            this.$emit('deviceRecorded', { dataURL: dataURL, blob: this.deviceRecorder.getBlob() })
          }
        }
        await this.releaseDevice()
      },
      async releaseDevice () {
        if (this.deviceRecorder) {
          if (this.deviceRecorder.state === 'recording') {
            await this.deviceRecorder.stopRecording()
          }
          this.deviceRecorder.stream.getTracks(t => t.stop())
          if (this.deviceRecorder.camera) {
            await this.deviceRecorder.camera.stop()
          }
          if (this.deviceRecorder.microphone) {
            await this.deviceRecorder.microphone.stop()
          }
          if (this.deviceRecorder.stream) {
            await this.deviceRecorder.stream.stop()
          }
          await this.deviceRecorder.reset()
          await this.deviceRecorder.destroy()
          this.deviceRecorder = null
        }
      },
      initCameraPlayer (sources, isStream) {
        if (!this.cameraPlayer) {
          this.cameraPlayer = videojs('cameraPlayer', {
            techOrder: ['html5'],
            width: this.activityPlayerWidth,
            height: this.activityPlayerHeight,
            controls: false,
            playsinline: true,
            muted: this.$store.getters.isSignLang,
            autoplay: true,
            preload: true
          })
        }
        this.cameraPlayer.reset()
        if (isStream) {
          this.cameraPlayer.volume(0)
          this.cameraPlayer.tech().el().srcObject = sources
        } else {
          this.cameraPlayer.volume(this.$store.state.globalVolume)
          this.cameraPlayer.one('ended', this.onRepeatCameraPlayerEnd)
          this.cameraPlayer.src(sources)
          // this.cameraPlayer.play()
        }
        this.cameraPlayerVisible = true
      },
      /* sendCompare (blob) {
        const formData = new FormData()
        formData.append('audioblob', blob)
        return this.$http.post(this.$store.getters.COMPARE_URL + '?cmd=compare' +
          '&str_pars[]=' + new Date().getTime() + '.flv' + // file name
          '&num_pars[]=' + this.phrase.id +
          '&num_pars[]=' + this.$store.state.langL.id,
          formData, NetTools.withCredentials)
          .then(response => {
            const result = XmlTools.parseXml(response.data, true)
            this.$emit('scoreResult', result)
          })
          .catch(error => {
            NetTools.handleError(error, this.$store, 'audioblob')
          })
      }, */
      /* async phraseSelected (item) {
        this.stopActivity()
        this.phraseDialog = false
        this.activityReady = false
        this.activityStarted = false
        this.showControls = false
        await BbTools.sleepCancelable(LearningTools.TO_HIDE_ACTIVITY, this.$store)
        this.movieFrame = ''
        if (this.activityIndex === item.index - 1) {
          this.$store.commit('setCurrPage', -1)
          await BbTools.sleepCancelable(100, this.$store)
        }
        this.$store.commit('setCurrPage', item.index - 1)
      }, */
      onPhrase () {
        this.$store.commit('hidePhrase')
      },
      onPhonetic () {
        this.$store.commit('hidePhonetic')
      },
      onNative () {
        this.$store.commit('hideNative')
      },
      async onPhoneticMode () {
        await UserTools.togglePhonetic(this.$store);
        if (this.quizPhrase.quizType === LearningTools.QUIZ_TRANSLATION2.id
          || this.quizPhrase.quizType === LearningTools.QUIZ_SPELLING.id) {
          this.$emit('phoneticModeChanged');
        }
      },
      onMute () {
        this.$store.commit('onMute')
        if (this.activityPlayer) {
          if (this.videoActivityWithEmbedAudio && this.$store.state.user.activityMuted) {
            this.activityPlayer.volume(0)
          } else {
            this.activityPlayer.volume(this.$store.state.globalVolume)
          }
        }
      },
      onDeviceEnabled () {
        this.deviceEnabled = true
      },
      onPhraseNumberChange () {
        if (this.phraseNumberDisplayClickable) {
          this.phraseDialog = true
        }
      },
      pictoGridImage (n) {
        if (this.pictoGridImages[n - 1]) {
          return this.pictoGridImages[n - 1]
        } else if (this.pictoGridItems) {
          if (this.$store.getters.isMovieLevel()) {
            return ''
          }
          return this.pictoGridItems[n - 1] ? this.pictoGridItems[n - 1].word_image : null
        } else {
          return null
        }
      },
      pictoGridImageStyle (n) {
        if (this.pictoGridItems.length > 0 && this.pictoGridItems[n - 1]) {
          return this.pictoGridItems[n - 1].style
            ? this.pictoGridItems[n - 1].style : 'border: 3px solid #1b242d; height: 100%;'
        } else {
          return 'border: 3px solid yellow; height: 100%;'
        }
      },
      pictoGridPhrase (n) {
        if (this.$store.state.hideNative) {
          return LearningTools.PHRASE_HIDDEN
        } else {
          return this.pictoGridItems[n - 1] ? this.pictoGridItems[n - 1].native_word : ''
        }
      },
      async onPictoGridImage (n) {
        if (this.hidePhraseActivity && this.activityReady) {
          this.pauseAllAudio()
          this.audioRepeated = -1 // do not play audio again if answered
          this.activityPlayerRepeated = -1
          this.pictoGridItems.forEach((item, index) => {
            if (this.pgActivityPlayers[index]) {
              this.pgActivityPlayers[index].pause()
            }
            if (item === this.quizPhrase && this.pgActivityPlayers[index]) {
              this.pgActivityPlayers[index].currentTime(0)
              this.pgActivityPlayers[index].play()
            }
          })

          let answerCorrect = this.pictoGridItems[n - 1].word === this.quizPhrase.phrase.word;

          if (this.isRapidTest) {
            this.nextQuestionResponse = await LearningTools.setAnswerAndGetNextRapidTestPhrase(
              this.$store,
              this.$router,
              this.quizPhrase.quizType,
              this.pictoGridItems[n - 1].native_word,
            );
            if (!this.nextQuestionResponse) {
              return;
            }
            answerCorrect = this.pictoGridItems[n - 1].word
              === this.nextQuestionResponse.data.previous_qz_answer.word;
          }

          if (answerCorrect) {
            this.$emit('scoreResult', 1, this.nextQuestionResponse)
            this.pictoGridItems[n - 1].style = 'border: 3px solid #4CAF50; height: 100%;'
          } else {
            this.$emit('scoreResult', 0, this.nextQuestionResponse)
            this.pictoGridItems[n - 1].style = 'border: 3px solid red; height: 100%;'
            if (this.pictoGridItems[this.pictoGridItems.indexOf(this.quizPhrase)]) {
              this.pictoGridItems[this.pictoGridItems.indexOf(this.quizPhrase)].style = 'border: 3px solid #4CAF50; height: 100%;'
            }
          }
        }
      },
      onPictoGridPhrase (event, n) {
        event.stopPropagation()
        this.onNative()
        if (this.$refs['gridButton' + n] && this.$refs['gridButton' + n][0] && this.$refs['gridButton' + n][0].$el) {
          this.$refs['gridButton' + n][0].$el.blur()
        }
      },
      calculatePictoGridHeight () {
        if (this.pictoGrid && this.$refs.card) {
          let result = this.$refs.card.$el.clientHeight / 2
          if (result < 120) {
            result = 120
          }
          if (result > 240) {
            result = 240
          }
          this.pictoGridImageHeight = result
        }
      },
      disposeActivityPlayers () {
        if (this.activityPlayer) {
          this.activityPlayer.off()
          this.activityPlayer.dispose()
          this.activityPlayer = null
        }
        if (this.preloadPlayer) {
          this.preloadPlayer.off()
          this.preloadPlayer.dispose()
          this.preloadPlayer = null
        }
        this.pgActivityPlayers.forEach(player => {
          player.dispose()
          player = null
        })
        this.pgActivityPlayers = []
        if (this.cameraPlayer) {
          this.cameraPlayer.off()
          this.cameraPlayer.dispose()
          this.cameraPlayer = null
        }
      },
      async onSignTypeChange () {
        if (this.activityReady) {
          this.activityReady = false
          this.activityStarted = false
          await BbTools.sleepCancelable(LearningTools.TO_START_PLAYING, this.$store)
          this.signVideoFront = !this.signVideoFront
          this.setActivityReady(null, false)
        }
      },
      onAbcTextClick () {
        if (this.$store.state.abcTextVisible) {
          if (this.$store.state.hidePhrase) {
            this.$store.commit('hidePhrase')
          }
          if (this.$store.state.hidePhonetic) {
            this.$store.commit('hidePhonetic')
          }
          if (this.$store.state.hideNative) {
            this.$store.commit('hideNative')
          }
        }
        this.$store.commit('abcTextVisible')
      },
      onGender () {
        this.genderArticlesOpened = !this.genderArticlesOpened
      },
      onArticle (type) {
        if (this.audioPlayer && this.audioPlayer.playing) {
          this.onAudioEnd()
        }
        this.pauseAllAudio()
        if (this.articlePlayer) this.articlePlayer.unload()
        const src = BbTools.replaceAll(this.phrase.audio, this.phrase.id + '\\.mp3' + BbTools.APP_POSTFIX,
          this.phrase.id + type + '.mp3' + BbTools.APP_POSTFIX)
        this.articlePlayer = new Howl({
          src: [src],
          volume: this.$store.state.globalVolume,
          autoplay: true
        })
      }
    },
    beforeDestroy () {
      this.activityReady = false
      this.activityStarted = false
      this.showControls = false
      this.stopActivity()
      if (this.$store.state.sleepPromise) {
        this.$store.state.sleepPromise.cancel()
      }
      if (this.audioPlayer) {
        this.audioPlayer.unload()
        this.audioPlayer = null
      }
      if (this.audioSlowPlayer) {
        this.audioSlowPlayer.off()
        this.audioSlowPlayer.dispose()
        this.audioSlowPlayer = null
      }
      if (this.articlePlayer) {
        this.articlePlayer.unload()
        this.articlePlayer = null
      }
      if (this.noAutoplayTimeout) {
        clearTimeout(this.noAutoplayTimeout)
      }
      this.disposeActivityPlayers()
    }
  }
/* eslint-disable */
</script>

<style>
  .stroketext {
    /* -webkit-text-stroke: 1px black; */
    -moz-text-shadow:1px 0 5px black, 1px -1px 5px black,0 1px 5px black,0 -1px 5px black, 0 0 5px black;
    -webkit-text-shadow:1px 0 5px black, 1px -1px 5px black,0 1px 5px black,0 -1px 5px black, 0 0 5px black;
    text-shadow:1px 0 5px black, 1px -1px 5px black,0 1px 5px black,0 -1px 5px black, 0 0 5px black;
    font-weight: 900;
  }

  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
  }

  .activity-phrase {
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
    width: 100%;
  }

  .vjs-caption-settings, .vjs-track-settings, .vjs-loading-spinner, .vjs-big-play-button, .vjs-control-bar, .vjs-error-display, .vjs-modal-dialog {
    display: none;
  }
</style>
